import React from "react";
import { Route, Routes, createBrowserRouter, useLocation, useNavigate } from "react-router-dom";
import { LoginPage, useAuth } from "../libs/auth";
import Shell from "../libs/shell";
import { logOut } from "../libs/auth/store/auth.slice";
import { useEffect } from "react";
import { useAppDispatch } from "../store/hooks/app-store.hook";
import Dashboard from "../feature/dashboard";
import { NotFoundPage } from "../libs/core";
import AwardAreaManager from "../feature/awardareas";
import UserManager from "../feature/users";
import BlogManager from "../feature/blogs";
import TeamProfileManager from "../feature/team";
import SubscribersManager from "../feature/newsletter";
import AwardAreaDetailPage from "../feature/awardareas/awardarea-detail";
import ProfilePage from "../feature/dashboard/profile_page";
import BlogDetailPage from "../feature/blogs/blog_details";
import TestimonialList from "../feature/testimonials";
import PartnerManager from "../feature/partners";
import ContactUsManager from "../feature/ContactUs";
import NewsLetterManager from "../feature/newsletter/news_letter_manager";
import NewsletterDetailPage from "../feature/newsletter/newsletter_detail";
import GalleryManager from "../feature/gallery";

export const Routing = (): JSX.Element => {
    /* hooks */
    const { session } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

  
    const localSession = localStorage.getItem("session");
  
    useEffect(() => {
      if (!session || !localSession) {
        dispatch(logOut());
        navigate("/login");
      } else if (session && location.pathname === "/login") {
        navigate("/");
      }
    }, [session, location.pathname, navigate, dispatch, localSession]);
  
    return (
      <>
        {/* <ScrollRestoration /> */}
        <Routes>
          {session === null && <Route path="/login" element={<LoginPage />} />}
  
          {session !== null && (
            <Route path="/" element={<>{<Shell />}</>}>
              <Route index element={<Dashboard/>}/>
              <Route path="/awardareas" element={<AwardAreaManager/>} />
              <Route path="/awardareas/:id" element={<AwardAreaDetailPage/>} />
              <Route path="/awards" element={require("../feature/award").default ? React.createElement(require("../feature/award").default) : null} />
              <Route path="/awards/:id" element={require("../feature/award/award-detail").default ? React.createElement(require("../feature/award/award-detail").default) : null} />
              <Route path="/users" element={<UserManager/>} />
              <Route path="/blogs" element={<BlogManager/>} />
              <Route path="/testimonials" element={<TestimonialList/>} />
              <Route path="/teams" element={<TeamProfileManager/>} />
              <Route path="/subscribers" element={<SubscribersManager/>} />
              <Route path="/profile" element={<ProfilePage/>} />
              <Route path="/blogs/:id" element={<BlogDetailPage/>} />
              <Route path="/partners" element={<PartnerManager/>} />
              <Route path="/messages" element={<ContactUsManager/>} />
              <Route path="/newsletters" element={<NewsLetterManager/>} />
              <Route path="/newsletters/:id" element={<NewsletterDetailPage/>} />
              <Route path="/gallery" element={<GalleryManager/>} />
            </Route>
          )}

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </>
    );
  };